export const companies = state => {
	return state.user.companies
}

export const questions = state => {
	return state.user.questions
}

export const modalVisible = state => {
	return state.user.modalVisible
}

export const modalComponent = state => {
	return state.user.modalComponent
}


// WEBPACK FOOTER //
// ./src/store/getters.js